<template>
    <div class="partner_report" style="width: 100%; margin-top: 30px; border-top: 1px solid #ddd">
        <div style="width:100%;height: 300px; margin-top: 20px; ">
            <canvas style="height: 300px;width: 100%" :id="analysis_data.banner_name_en"></canvas>
        </div>             
    </div>
</template>
<script>
window.chartColors = {
	red: 'rgb(255, 99, 132)',
	orange: 'rgb(255, 159, 64)',
	yellow: 'rgb(255, 205, 86)',
	green: 'rgb(75, 192, 192)',
	blue: 'rgb(54, 162, 235)',
	purple: 'rgb(153, 102, 255)',
	grey: 'rgb(201, 203, 207)'
};

export default {
    props:["analysis_data"],
    mounted(){
         var content_config = {
			type: 'line',
			data: {
				labels: this.analysis_data.click_data.map( el=>el.date ) ,
				datasets: [
                    {
                        label: '클릭수',
                        backgroundColor: window.chartColors.blue,
                        borderColor: window.chartColors.blue,
                        data: this.analysis_data.click_data.map( el=>el.count ),
                        fill: false,
                    },
                    {                   
                        label: '조회수',
                        backgroundColor: window.chartColors.red,
                        borderColor: window.chartColors.red,
                        data: this.analysis_data.view_data.map( el=>el.count ),
                        fill: false,
                    }],
                }
            , 
			options: {
				responsive: true,
				title: {
					display: true,
					text: this.analysis_data.banner_name + ' 클릭/조회 추이'
				},
				tooltips: {
					mode: 'index',
					intersect: false,
				},
				hover: {
					mode: 'nearest',
					intersect: true
				},
				scales: {
					x: {
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'date'
						}
					},
					y: {
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'Value'
                        },                        
                    },
                    yAxes: [{
                        ticks: {
                        stepSize: 1
                        }
                    }],
                    xAxes: [{
                        offset: true
                    }]
				}
			}
        };
    var content_ctx = document.getElementById(this.analysis_data.banner_name_en).getContext('2d');
    window.content_line = new Chart(content_ctx, content_config);
    }

}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/SPA/PartnerMypage/Components/PartnerReport/CampaignReportChart.vue